import { Injectable } from '@angular/core';
import { PhAuthService } from '@frontend/common/src/lib/ph-auth';
import { PhConfigLoaderService } from '@frontend/common/src/lib/ph-config-loader';
import { CurrentCustomerService } from '@frontend/common/src/lib/util';
import { Customer } from '@frontend/entity';
import { combineLatest, Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';

interface LicenseInfo {
  is_assets_rt_enabled: boolean;
  is_duress_rt_enabled: boolean;
  is_hand_hygiene_enabled: boolean;
  is_workflow_rt_enabled: boolean;
}
@Injectable()
export class AppSwitcherService {
  customer$ = this.currentCustomerSrv.customer$.pipe(shareReplay(1));
  licenses$: Observable<LicenseInfo>;
  subdomain$: Observable<string>;

  assetsAvailable$: Observable<boolean>;
  assetsTplURL$: Observable<string>;
  assetsURL$: Observable<string>;

  duressAvailable$: Observable<boolean>;
  duressTplURL$: Observable<string>;
  duressURL$: Observable<string>;

  hhAvailable$: Observable<boolean>;
  hhTplURL$: Observable<string>;
  hhURL$: Observable<string>;

  caAvailable$: Observable<boolean>;
  caURL$: Observable<string>;
  caTplURL$: Observable<string>;

  connectTplURL$: Observable<string>;
  connectURL$: Observable<string>;

  constructor(
    private phAuthSrv: PhAuthService,
    private config: PhConfigLoaderService,
    private currentCustomerSrv: CurrentCustomerService
  ) {
    this.licenses$ = this.customer$.pipe(
      map((customerData: Customer) => customerData?.license_info)
    );
    this.subdomain$ = this.customer$.pipe(
      map((customerData: Customer) => customerData?.subdomain)
    );

    this.assetsTplURL$ = this.config.getConfig$('FRONTEND_ART_URL');
    this.duressTplURL$ = this.config.getConfig$('FRONTEND_DRT_URL');
    this.caTplURL$ = this.config.getConfig$('FRONTEND_CA_URL');
    this.hhTplURL$ = this.config.getConfig$('FRONTEND_HH_URL');
    this.connectTplURL$ = this.config.getConfig$('FRONTEND_CONNECT_RT_HOME_URL');

    this.assetsAvailable$ = combineLatest({
      permission: this.phAuthSrv.scopes$.pipe(map((scopes: string[]) => scopes.includes('access:art'))),
      license: this.licenses$.pipe(map((licenses) => !!licenses?.is_assets_rt_enabled)),
    }).pipe(map(({ permission, license }) => permission && license));

    this.assetsURL$ = combineLatest({
      tpl: this.assetsTplURL$, 
      subdomain: this.subdomain$
    }).pipe(
      map(({ tpl, subdomain }) => tpl.replace('[CUSTOMER]', subdomain))
    );

    this.caAvailable$ = this.phAuthSrv.scopes$.pipe(
      map((scopes: string[]) => scopes.includes('access:ca'))
    );

    this.caURL$ = combineLatest({
      tpl: this.caTplURL$, 
      subdomain: this.subdomain$
    }).pipe(
      map(({ tpl, subdomain }) => tpl.replace('[CUSTOMER]', subdomain))
    );

    this.duressURL$ = combineLatest({
      tpl: this.duressTplURL$, 
      subdomain: this.subdomain$
    }).pipe(
      map(({ tpl, subdomain }) => tpl.replace('[CUSTOMER]', subdomain))
    );

    this.hhAvailable$ = combineLatest({
      permission: this.phAuthSrv.scopes$.pipe(map((scopes: string[]) => scopes.includes('access:hh'))),
      license: this.licenses$.pipe(map((licenses) => !!licenses?.is_hand_hygiene_enabled)),
    }).pipe(map(({ permission, license }) => permission && license));

    this.duressAvailable$ = combineLatest({
      permission: this.phAuthSrv.scopes$.pipe(map((scopes: string[]) => scopes.includes('access:drt'))),
      license: this.licenses$.pipe(map((licenses) => !!licenses?.is_duress_rt_enabled)),
    }).pipe(map(({ permission, license }) => permission && license));

    this.hhURL$ = combineLatest({
      tpl: this.hhTplURL$, 
      subdomain: this.subdomain$
    }).pipe(
      map(({ tpl, subdomain }) => tpl.replace('[CUSTOMER]', subdomain))
    );

    this.duressURL$ = combineLatest({
      tpl: this.duressTplURL$, 
      subdomain: this.subdomain$
    }).pipe(
      map(({ tpl, subdomain }) => tpl.replace('[CUSTOMER]', subdomain))
    );

    this.connectURL$ = combineLatest({
      tpl: this.connectTplURL$, 
      subdomain: this.subdomain$
    }).pipe(
      map(({ tpl, subdomain }) => tpl.replace('[CUSTOMER]', subdomain))
    );
  }
}
